export class MockDataConstants {
	public static readonly defaultPortfolioFamilyResponse = {
		showBenchmark: false,
		isDefaultFamilyForVehiclePref: true,
		vehicle1: true,
		portfolioFamilySchema: {
			familyCode: 'target_allocation_tax_aware',
			familyName: 'Target Allocation Tax-Aware',
			portfolios: [{ id: 296895, name: 'BlackRock Fixed Income Target Allocation Tax Aware Model' }],
			docIds: [{ materialType: 'QUARTERLY_ALLOCATION', docId: 1473086 }]
		}
	};
	public static readonly additionalPortfolioFamilyResponse = {
		showBenchmark: false,
		portfolioFamilySchema: {
			familyCode: 'tax_aware_target_allocation_etf',
			familyName: 'Target Allocation Tax-Aware ETF',
			rebalDocId: 1473083,
			portfolios: [
				{ id: 296887, name: 'BlackRock Fixed Income Target Allocation Tax Aware ETF Model' },
				{ id: 296894, name: 'BlackRock 10/90 Target Allocation Tax Aware ETF Model' }
			],
			docIds: [{ materialType: 'QUARTERLY_ALLOCATION', docId: 1473086 }],
			showBenchmark: false
		}
	};
	public static readonly portfolioFamiliesResponse = [MockDataConstants.defaultPortfolioFamilyResponse, MockDataConstants.additionalPortfolioFamilyResponse];
	public static readonly mockDataResponse = {
		portfolioFamilies: MockDataConstants.portfolioFamiliesResponse
	};
	public static readonly mockAdditionalFamily = {
		familyCode: 'tax_aware_target_allocation_etf',
		familyName: 'Target Allocation Tax-Aware ETF',
		rebalDocId: 1473083,
		portfolios: [
			{ id: 296887, name: 'BlackRock Fixed Income Target Allocation Tax Aware ETF Model' },
			{ id: 296894, name: 'BlackRock 10/90 Target Allocation Tax Aware ETF Model' }
		],
		docIds: [{ materialType: 'QUARTERLY_ALLOCATION', docId: 1473086 }],
		showBenchmark: false
	};
	public static readonly mockDefaultFamily = {
		isDefaultFamilyForVehiclePref: true,
		familyCode: 'target_allocation_tax_aware',
		familyName: 'Target Allocation Tax-Aware',
		portfolios: [{ id: 296895, name: 'BlackRock Fixed Income Target Allocation Tax Aware Model' }],
		docIds: [{ materialType: 'QUARTERLY_ALLOCATION', docId: 1473086 }]
	};

	public static readonly mockModelPortfolio1: any = {
		baseModel: '',
		asOfDateType: '',
		netExpenseRatio: 2.2493,
		portfolioId: 270903,
		yieldValue: 2.7493,
		yieldAsOfDate: 20180531,
		holdingAsOfDate: '20180403',
		standardDeviationAsOfDate: 20180530,
		standardDeviation: null,
		isAssetClassOnly: false,
		prevRebalancedDate: '20180116'
	};
	public static readonly mockModelPortfolio2: any = {
		baseModel: '',
		asOfDateType: '',
		netExpenseRatio: 2.2493,
		netExpenseRatioAsOfDate: 20180530,
		portfolioId: 270403,
		yieldValue: 2.2493,
		yieldAsOfDate: 2018053,
		standardDeviationAsOfDate: 20180530,
		holdingAsOfDate: '20180303',
		standardDeviation: null,
		isAssetClassOnly: false,
		prevRebalancedDate: '20180116'
	};

	public static readonly mockExAntiData1 = {
		uniqueId: '270903',
		totalRisk: 3.489713300955112,
		asOfDate: 20180531
	};

	public static readonly mockExAntiData2 = {
		uniqueId: '270403',
		totalRisk: 3.489713300955112,
		asOfDate: 20180531
	};
}
